import React from "react";
import { Button, Container, Desc, Img, Title, Wrapper } from "./style";
import Image from "../../assets/imgs/cover.png";

export default function About() {
  return (
    <Container title reveal>
      <Title title>About Me</Title>
      <Title range />
      <Wrapper content>
        <Wrapper column colLeft reveal>
          <Wrapper imgCard>
            <Img src={Image} alt="cover" />
          </Wrapper>
        </Wrapper>
        <Wrapper colRight reveal>
          <Title myTitle contentTitle>
            Hey there. I am Sardorbek
          </Title>
          <Desc>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nobis minus aspernatur quam
            similique rerum facilis non maxime, nihil molestiae eaque? Voluptatum, ipsa minus
            perspiciatis quam at sint atque sequi illo rerum dolor repellendus doloribus magnam
            veniam corporis labore distinctio ut perferendis inventore fuga architecto ea! Incidunt
            eveniet labore ex iusto nam, laboriosam, quidem molestias et soluta quod deserunt
            doloribus hic in tempora error tempore eius mollitia! Fugit ipsum ex possimus.
          </Desc>
          <br />
          <Desc>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nobis minus aspernatur quam
            similique rerum facilis non maxime, nihil molestiae eaque? Voluptatum, ipsa minus
            perspiciatis quam at sint atque sequi illo rerum dolor repellendus doloribus magnam
            veniam corporis labore distinctio ut perferendis inventore fuga architecto ea! Incidunt
            eveniet labore ex iusto nam, laboriosam, quidem molestias et
          </Desc>

          <Button about>See more</Button>
        </Wrapper>
      </Wrapper>
    </Container>
  );
}
